var RuntimeTraitInfo = /** @class */ (function () {
    function RuntimeTraitInfo(multiname, kind, _abc) {
        this.multiname = multiname;
        this.kind = kind;
        this._abc = _abc;
        this.configurable = true; // Always true.
        this.typeName = null;
        this._type = undefined;
    }
    RuntimeTraitInfo.prototype.getType = function () {
        if (this._type !== undefined)
            return this._type;
        if (this.typeName === null)
            return this._type = null;
        var type = this._abc.applicationDomain.getClass(this.typeName);
        return this._type = (type && type.axCoerce) ? type : null;
    };
    return RuntimeTraitInfo;
}());
export { RuntimeTraitInfo };
